import { env } from "@/env";

export const WALLEY_PAYMENT_TYPE = {
  b2c: "b2c",
  b2b: "b2b",
} as const;

export type WalleyPaymentType =
  (typeof WALLEY_PAYMENT_TYPE)[keyof typeof WALLEY_PAYMENT_TYPE];

export const DELIVERY_ITEM_PARTNO =
  env.NEXT_PUBLIC_NSHIFT_DYNAMIC_FREIGHT_PARTNO;

export const CHECKOUT_STORAGE_KEY = "ng_checkout";

export const STOCK_WATCH_BLOCKED = "STOCK_WATCH_BLOCKED";

export const NSHIFT_SCRIPT_SRC =
  "https://api.unifaun.com/rs-extapi/v1/delivery-checkouts-widget/unifaun-checkout-all.min.js";
